
const rolesStore = {
    state:() => ({
        roles: [
            'Admin',
            'Manager',
            'Contributor'
        ]
    }),
    actions: {
        getRoles: async ({commit}) => {
            // ENDPOINT IN THE FUTURE?
        }
    },
    mutations: {
        setRoles: (state, roles) => {
            state.roles = roles
        },
    },
    getters: {
        getRoles: state => {
            return state.roles
        }
    }
}

export default rolesStore